import { useState } from "react";
import { Modal } from "react-bootstrap";
import businessDocumentItemVM from "./businessDocumentItemVM";
import Index from "./index";

export const BusinessDocumentItemSelectorDialog = (props: {
  show: boolean;
  ok: (businessDocument: businessDocumentItemVM) => void;
  cancel: () => void;
  businessDocumentType: number;
  documentNumber: string;
}) => {
  const [selectedbusinessDocumentItem, setSelectedbusinessDocumentItem] =
    useState<businessDocumentItemVM | null>(null);

  const onClick = (businessDocumentItem: businessDocumentItemVM) => {
    setSelectedbusinessDocumentItem(businessDocumentItem);
  };

  const onDoubleClick = (businessDocumentItem: businessDocumentItemVM) => {
    setSelectedbusinessDocumentItem(businessDocumentItem);
    props.ok(businessDocumentItem);
    setSelectedbusinessDocumentItem(null); // do not preserve the selected item after closing
  };

  return (
    <div className="static-modal">
      <Modal
        animation={false}
        show={props.show}
        onHide={props.cancel}
        backdrop="static"
        keyboard={true}
        size="xl"
        fullscreen="xl-down"
      >
        <Modal.Header>
          <Modal.Title>
            Wybierz pozycję dokumentu {props.documentNumber}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Index
            onClick={onClick}
            onDoubleClick={onDoubleClick}
            businessDocumentType={props.businessDocumentType}
            documentNumber={props.documentNumber}
          ></Index>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            name="ok"
            className="btn btn-primary px-5 py-1"
            onClick={() => {
              props.ok(selectedbusinessDocumentItem!);
              setSelectedbusinessDocumentItem(null); // do not preserve the selected item after closing
            }}
            disabled={!selectedbusinessDocumentItem}
          >
            OK
          </button>
          <button
            type="button"
            name="cancel"
            className="btn btn-secondary px-5 py-1"
            onClick={props.cancel}
          >
            Anuluj
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BusinessDocumentItemSelectorDialog;
